import React from "react";
import CampaignsMultiForm from "../../../components/campaigns/multichannel/CampaignsMultiForm";

const _NewCampaignMulti = () => {
  return (
    <>
      <div className="text-3xl py-2 font-bold text-gray-600">Nueva Campaña</div>
      <CampaignsMultiForm />
    </>
  );
};

export default _NewCampaignMulti;
